// extracted by mini-css-extract-plugin
export default {"angles":"Video_angles__pTq69"};